/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LocalitySuggestion } from '../models/LocalitySuggestion';
import type { StreetSuggestion } from '../models/StreetSuggestion';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AddressesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Search localities
     * Search German localities (city + zip pairs) by zip code and/or name prefix
     * @param postalCode
     * @param name
     * @returns LocalitySuggestion
     * @throws ApiError
     */
    public searchLocalities(
        postalCode?: string,
        name?: string,
    ): CancelablePromise<Array<LocalitySuggestion>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/addresses/localities',
            query: {
                'postalCode': postalCode,
                'name': name,
            },
        });
    }
    /**
     * Search streets
     * Search German streets by name prefix, optionally narrowed by zip code and/or locality
     * @param name
     * @param postalCode
     * @param locality
     * @returns StreetSuggestion
     * @throws ApiError
     */
    public searchStreets(
        name: string,
        postalCode?: string,
        locality?: string,
    ): CancelablePromise<Array<StreetSuggestion>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/addresses/streets',
            query: {
                'name': name,
                'postalCode': postalCode,
                'locality': locality,
            },
        });
    }
}
